import { Input, Label, Wrapper } from './radioButtonStyle';

interface IProps {
  name: string;
  value?: string;
  option: string;
  label?: string;
  onChange?;
}

const RadioButtonView = ({ name, value, option, label, onChange }: IProps) => {
  return (
    <Wrapper>
      <Input
        {...{
          name,
          id: name,
          value: option,
          checked: value === option ? true : false,
          onChange: (e) => onChange(e.target.value),
          type: 'radio',
        }}
      />
      <Label htmlFor={name}>{label}</Label>
    </Wrapper>
  );
};

export default RadioButtonView;
